/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CopyFolderItemDtoFromJSON, CopyFolderItemDtoToJSON, } from './CopyFolderItemDto';
/**
 * Check if a given object implements the CopyFolderDto interface.
 */
export function instanceOfCopyFolderDto(value) {
    if (!('folders' in value) || value['folders'] === undefined)
        return false;
    if (!('newParentId' in value) || value['newParentId'] === undefined)
        return false;
    if (!('index' in value) || value['index'] === undefined)
        return false;
    return true;
}
export function CopyFolderDtoFromJSON(json) {
    return CopyFolderDtoFromJSONTyped(json, false);
}
export function CopyFolderDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'folders': (json['folders'].map(CopyFolderItemDtoFromJSON)),
        'newParentId': json['newParentId'],
        'index': json['index'],
    };
}
export function CopyFolderDtoToJSON(json) {
    return CopyFolderDtoToJSONTyped(json, false);
}
export function CopyFolderDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'folders': (value['folders'].map(CopyFolderItemDtoToJSON)),
        'newParentId': value['newParentId'],
        'index': value['index'],
    };
}
